import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function SectionHeader({ title, subtitle, linkTo, linkLabel = "Voir tout", testId, children }) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4 sm:mb-8">
      <div>
        {subtitle && <p className="label-eyebrow mb-2">{subtitle}</p>}
        <h2 className="font-display text-[22px] font-extrabold leading-tight text-ink sm:text-3xl" data-testid={testId}>
          {title}
        </h2>
        {children}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          data-testid={`${testId}-link`}
          className="group flex shrink-0 items-center gap-1.5 text-xs font-bold text-brand transition-colors duration-200 hover:text-brand-dark sm:text-sm"
        >
          <span className="hidden sm:inline">{linkLabel}</span>
          <span className="sm:hidden">Voir tout</span>
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      )}
    </div>
  );
}

export default SectionHeader;
